import { useLayoutEffect, useRef } from "react";
import { Textarea } from "../ui/textarea";

export const DocumentTextField = ({ value, onChange, readOnly = false, testId, ...props }) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const resize = () => { element.style.height = "auto"; element.style.height = `${Math.max(element.scrollHeight, 96)}px`; };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [value, readOnly]);
  if (readOnly) return <p className="min-w-0 whitespace-pre-wrap break-words [overflow-wrap:anywhere] text-sm leading-relaxed text-slate-700" data-testid={testId}>{value || "—"}</p>;
  return <Textarea ref={ref} {...props} value={value || ""} onChange={onChange} rows={3} className="input-field min-h-24 w-full resize-y text-sm leading-relaxed" data-testid={testId} />;
};